/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'cursed',
    quality: 0,
    learning: -1,
	perception: -1,
	mana: -1,
	toughness: -1,
	strength: -1,
	willpower: -1,
	dexterity: -1
}